export default __webpack_public_path__ + "static/media/November2010.48c4ff14.png";